// Custom getLayoutModules that merges hexa-core layouts with local overrides
// Files in src/layouts/ will override files with the same path from hexa-core/layouts/
export type LayoutModule = Record<string, unknown>;

export const getLayoutModules = (): Record<string, LayoutModule> => {
  // Load custom/override layouts from src
  const customModules: Record<string, LayoutModule> = import.meta.glob('/layouts/**/*.ts', { eager: true });

  // Load hexa-core layouts
  const hexaCoreModules: Record<string, LayoutModule> = import.meta.glob('/hexa-core/layouts/**/*.ts', { eager: true });

  // Merge modules, with custom modules overriding hexa-core ones
  // Normalize keys to match by removing the base path
  const normalizedModules: Record<string, LayoutModule> = {};

  // First add all hexa-core modules with normalized keys
  Object.entries(hexaCoreModules).forEach(([key, module]) => {
    const normalizedKey = key.replace('/hexa-core/layouts', '/layouts');
    normalizedModules[normalizedKey] = module;
  });

  // Then override with custom modules
  Object.entries(customModules).forEach(([key, module]) => {
    normalizedModules[key] = module;
  });

  return normalizedModules;
};
